module.exports = __webpack_public_path__ + "img/logo.6825d2d6.svg";